//editor
export const SELECT_EDITOR_SURFACE = "SELECT_EDITOR_SURFACE"
export const SELECT_EDITOR_PATTERN = "SELECT_EDITOR_PATTERN"
export const UPDATE_EDITOR_LEFT_PANEL_STATUS = "UPDATE_EDITOR_LEFT_PANEL_STATUS"
export const UPDATE_EDITOR_RIGHT_PANEL_STATUS =
  "UPDATE_EDITOR_RIGHT_PANEL_STATUS"
export const UPDATE_EDITOR_PREVIEW_STATUS = "UPDATE_EDITOR_PREVIEW_STATUS"
export const UPDATE_EDITOR_PATTERN_CONFIGS = "UPDATE_EDITOR_PATTERN_CONFIGS"
export const CLEAR_EDITOR = "CLEAR_EDITOR"
export const TOGGLE_EDITOR_PREVIEW_FULLSCREEN =
  "TOGGLE_EDITOR_PREVIEW_FULLSCREEN"
export const CREATE_EDITOR_CONFIGS = "CREATE_EDITOR_CONFIGS"
export const SAVE_EDITOR_CONFIGS = "SAVE_EDITOR_CONFIGS"
export const SET_EDITOR_MODEL = "SET_EDITOR_MODEL"

// user
export const FETCH_USER_ADMIN_RESOURCES = "FETCH_USER_ADMIN_RESOURCES";
export const FETCH_USER_ADMIN_RESOURCES_SUCCEEDED = "FETCH_USER_ADMIN_RESOURCES_SUCCEEDED";
export const FETCH_USER_ADMIN_RESOURCES_FAILED = "FETCH_USER_ADMIN_RESOURCES_FAILED";
export const FETCH_USER = "FETCH_USER"
export const SET_USER = "SET_USER"
export const UNSET_USER =  "UNSET_USER"
export const UPDATE_USER = "UPDATE_USER"
export const DELETE_USER = "DELETE_USER"
export const UPDATE_USER_HAS_VISITED = "UPDATE_USER_HAS_VISITED"

// auth
export const SIGNUP = "SIGNUP"
export const SECURITY_SIGNIN = "SECURITY_SIGNIN"
export const SIGNIN = "SIGNIN"
export const SIGNOUT = "SIGNOUT"
export const SET_LOADED = "SET_LOADED"
export const RESET_PASSWORD = "RESET_PASSWORD"

//folders
export const CREATE_FOLDER = "CREATE_FOLDER"
export const UPDATE_FOLDER = "UPDATE_FOLDER"
export const FETCH_FOLDERS = "FETCH_FOLDERS"
export const SET_FOLDERS = "SET_FOLDERS"
export const SET_FOLDER = "SET_FOLDER"
export const DELETE_FOLDER = "DELETE_FOLDER"
export const DELETE_FOLDER_CONFIRMED = "DELETE_FOLDER_CONFIRMED"
export const UNSET_FOLDER = "UNSET_FOLDER"

// models
export const CREATE_MODEL = "CREATE_MODEL"
export const UPDATE_MODEL = "UPDATE_MODEL"
export const FETCH_MODEL = "FETCH_MODEL"
export const FETCH_MODELS = "FETCH_MODELS"
export const SET_MODELS = "SET_MODELS"
export const SET_MODEL = "SET_MODEL"
export const DELETE_MODEL = "DELETE_MODEL"
export const UNSET_MODEL = "UNSET_MODEL"
export const MODEL_NOT_FOUND = "MODEL_NOT_FOUND"

// exports
export const CREATE_MODEL_EXPORT = "CREATE_MODEL_EXPORT"
export const FETCH_MODEL_EXPORT = "FETCH_MODEL_EXPORT"
export const SET_MODEL_EXPORT = "SET_MODEL_EXPORT"
export const CLEAR_MODEL_EXPORT = "CLEAR_MODEL_EXPORT"

// modals
export const MODAL_OPEN = "MODAL_OPEN"
export const MODAL_CLOSE = "MODAL_CLOSE"
export const MODAL_CONFIRMED = "MODAL_CONFIRMED"

// ui
export const UI_OPEN_LEFT_SIDEBAR = "UI_OPEN_LEFT_SIDEBAR";
export const UI_OPEN_RIGHT_SIDEBAR = "UI_OPEN_RIGHT_SIDEBAR";
export const UI_CLOSE_LEFT_SIDEBAR = "UI_CLOSE_LEFT_SIDEBAR";
export const UI_CLOSE_RIGHT_SIDEBAR = "UI_CLOSE_RIGHT_SIDEBAR";
export const UI_COLLAPSE_SURFACE_PANEL = "UI_COLLAPSE_SURFACE_PANEL";
export const UI_OPEN_SURFACE_PANEL = "UI_OPEN_SURFACE_PANEL";
export const UI_EXPAND_SURFACE_PANEL = "UI_EXPAND_SURFACE_PANEL";
export const UI_COLLAPSE_PATTERN_PANEL = "UI_COLLAPSE_PATTERN_PANEL";
export const UI_OPEN_PATTERN_PANEL = "UI_OPEN_PATTERN_PANEL";
export const UI_EXPAND_PATTERN_PANEL = "UI_EXPAND_PATTERN_PANEL";
export const UI_SHOW_HEADER = "UI_SHOW_HEADER";
export const UI_HIDE_HEADER = "UI_HIDE_HEADER";
export const UI_SHOW_SUPPORT_CARD = "UI_SHOW_SUPPORT_CARD";
export const UI_HIDE_SUPPORT_CARD = "UI_HIDE_SUPPORT_CARD";
export const UI_SET_EDITOR = "UI_SET_EDITOR";

// locale
export const SET_LOCALE_LNG = "SET_LOCALE_LNG";

// contact
export const CREATE_CONTACT = "CONTACT";
export const SET_CONTACT_SUCCESS = "SET_CONTACT_SUCCESS";
export const UNSET_CONTACT_SUCCESS = "UNSET_CONTACT_SUCCESS";



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js